/** The hashed main bundle this page runs ("main.e5827e23.js"), or null on the dev server. */
export function currentBuildName() {
  try {
    const s = Array.from(document.scripts || []).find((el) => /\/static\/js\/main\.[0-9a-f]+\.js/.test(el.src || ""));
    const m = s ? /main\.([0-9a-f]+)\.js/.exec(s.src) : null;
    return m ? m[1] : null;
  } catch (e) {
    return null;
  }
}
